/* NKED announcement-bar menu dropdown.
   Native <details> handles open/close on the icon. This adds:
   - close on click anywhere outside the menu
   - close on Escape (and return focus to the icon)
   - when a link points at the page you're already on, smooth-scroll to top
     instead of a no-op navigation. */
class NkedMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this._onDocClick = this._onDocClick.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
  }

  connectedCallback() {
    if (!this.details || !this.summary) return;

    this.details.addEventListener('toggle', () => {
      const open = this.details.open;
      this.summary.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        document.addEventListener('click', this._onDocClick);
        document.addEventListener('keydown', this._onKeyDown);
      } else {
        document.removeEventListener('click', this._onDocClick);
        document.removeEventListener('keydown', this._onKeyDown);
      }
    });

    this.querySelectorAll('[data-scroll-top]').forEach((link) => {
      link.addEventListener('click', (event) => {
        try {
          const target = new URL(link.href, window.location.origin);
          if (
            target.pathname === window.location.pathname &&
            target.search === window.location.search
          ) {
            event.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        } catch (err) {
          /* bad URL — let the browser handle the click */
        }
        this.close();
      });
    });
  }

  _onDocClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  _onKeyDown(event) {
    if (event.key === 'Escape') {
      this.close();
      this.summary.focus();
    }
  }

  close() {
    this.details.open = false;
  }
}

if (!customElements.get('nked-menu-dropdown')) {
  customElements.define('nked-menu-dropdown', NkedMenuDropdown);
}
